import React from 'react';
import { FaWifi, FaTachometerAlt } from 'react-icons/fa';
import { Card, CardBody } from 'reactstrap';

const NetworkSpeedDisplay = ({ summary }) => {
  const getSpeedColorClass = (speed) => {
    const speedMbps = +speed / 1000000;
    if (speedMbps > 10) return '#28a745';
    if (speedMbps > 5) return '#17a2b8';
    if (speedMbps > 1) return '#ffc107';
    return '#dc3545';
  };

  return (
    <div className="m-b-10 network-speed-metrics d-flex align-items-center justify-content-between">
      {summary?.averageSpeed ? (
        <Card className="border-0">
          <CardBody className="p-3">
            <div className="d-flex align-items-center">
              <div
                style={{
                  backgroundColor: '#e9ecef',
                  padding: '10px',
                  borderRadius: '50%',
                  marginRight: '15px',
                }}
              >
                <FaWifi
                  style={{ color: getSpeedColorClass(summary.averageSpeed) }}
                  size={24}
                />
              </div>
              <div>
                <div className="fw-bold" style={{ fontSize: '16px' }}>
                  Average Speed
                </div>
                <div
                  style={{
                    color: getSpeedColorClass(summary.averageSpeed),
                    fontSize: '20px',
                    fontWeight: '600',
                  }}
                >
                  {(+summary.averageSpeed / 1000000).toFixed(2)} Mbps
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      ) : null}

      {summary?.minimumSpeed ? (
        <Card className="border-0">
          <CardBody className="p-3">
            <div className="d-flex align-items-center">
              <div
                style={{
                  backgroundColor: '#e3e3e3',
                  padding: '10px',
                  borderRadius: '50%',
                  marginRight: '15px',
                }}
              >
                <FaTachometerAlt
                  style={{ color: getSpeedColorClass(summary.minimumSpeed) }}
                  size={24}
                />
              </div>
              <div>
                <div className="fw-bold" style={{ fontSize: '16px' }}>
                  Minimum Speed
                </div>
                <div
                  style={{
                    color: getSpeedColorClass(summary.minimumSpeed),
                    fontSize: '20px',
                    fontWeight: '600',
                  }}
                >
                  {(+summary.minimumSpeed / 1000000).toFixed(2)} Mbps
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      ) : null}
    </div>
  );
};

export default NetworkSpeedDisplay;
